import useNavConfig from '@hooks/useNavConfig';
import { NavbarItem } from '@nextui-org/react';
import { Link, useLocation } from 'react-router-dom';

export const NavItem = ({ item }: any) => {
  const { pathname } = useLocation();
  const isChildren = !!item?.items?.length;
  return (
    <NavbarItem isActive={pathname?.includes(item?.key)}>
      <Link aria-current="page" className="flex gap-2 text-inherit" to={item?.key}>
        {item?.title}
      </Link>
    </NavbarItem>
  );
};
